import { Directive, HostListener, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[appTouchTooltip]',
})
export class TouchTooltipDirective {
    private readonly tooltip = inject(MatTooltip);
    private static activeTooltip: MatTooltip | null = null;

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        if (TouchTooltipDirective.activeTooltip === this.tooltip) {
            this.tooltip.hide(0);
            TouchTooltipDirective.activeTooltip = null;
            return;
        }

        TouchTooltipDirective.activeTooltip?.hide(0);
        TouchTooltipDirective.activeTooltip = this.tooltip;
        this.tooltip.show(0);
    }

    @HostListener('document:click')
    onOutsideClick(): void {
        TouchTooltipDirective.activeTooltip?.hide(0);
        TouchTooltipDirective.activeTooltip = null;
    }
}
